import React from 'react';
import {observer} from 'mobx-react';
import AccountPreferences from './AccountPreferences';
import Password from './Password';
import ToggleOAuth from './ToggleOAuth';
import MultiFactorAuthenticationContainer from './MultiFactorAuthenticationContainer';

const AuthSettings = observer(({uiState}) => {
  const {hideOAuth = false} = uiState;

  return (
    <React.Fragment>
      <AccountPreferences uiState={uiState}/>
      <Password uiState={uiState}/>
      {!hideOAuth && <ToggleOAuth uiState={uiState}/>}
      <MultiFactorAuthenticationContainer uiState={uiState}/>
    </React.Fragment>
  );
});

export default AuthSettings;
